/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { ReleaseVersionData } from 'cio/services/release-notification';

interface CioAppFooterArgs {
  release: ReleaseVersionData;
}

export default class CioAppFooter extends Component<CioAppFooterArgs> {
  logoColorImage = new URL('cio/assets/images/logo-color.svg', import.meta.url).toString();
}
